@let array = formArray();
@if (array) {
  <div [formGroup]="$any(array)" class="building-section" [nbSpinner]="loader()">

      <div class="building-section-header">
        <div class="info-text">
          <nb-icon pack="eva" icon="alert-circle-outline"></nb-icon>
          Jeder Gebäudeteil kann mehrere Adressen haben. Jede Straße kann mehrere Hausnummern haben.
        </div>

        @if (!formGroup()?.disabled) {
          <div class="header-actions">

            <button nbButton status="primary" (click)="addBuildingSection()" nbTooltip="Gebäudeteil hinzufügen">
              <nb-icon pack="eva" icon="plus-outline"></nb-icon>
            </button>
          </div>
        }
      </div>

    @if (touched() && !hasActiveSections() && !formGroup()?.disabled) {
      <small class="text-danger">Mindestens ein Gebäudeteil ist erforderlich</small>
    }

    <div class="building-section-list">
      @for (section of controls(); track $index; let i = $index) {
        @if (sectionHasNonDeletedHouseNumbers($any(section))){
          <div [formGroupName]="i" class="building-section-item-wrapper">

          <div class="building-section-item">
            <div class="building-section-row">
              <div class="street-col">
                <label class="label" [for]="'street-' + i">Straße</label>
                <input nbInput
                       fullWidth
                       [id]="'street-' + i"
                       type="text"
                       formControlName="street"
                       [status]="hasControlError(section.get('street')) ? 'danger' : 'basic'"
                       placeholder="Straße">
                @if (hasControlError(section.get('street'))) {
                  <small class="text-danger">Straße erforderlich</small>
                }
              </div>
            </div>

            <div class="building-section-row">
              <div class="house-numbers-container">
                <label class="label">Hausnummer(n)</label>

                <div class="number-col" formArrayName="houseNumbers">
                  @for (houseNumber of houseNumbers(i).controls; track $index; let j = $index) {
                    @if (houseNumber.get('markedForDeletion')?.value !== true) {
                      <div class="number-item" [formGroupName]="j" [class.has-two-suffixes]="!formGroup()?.disabled">
                        <nb-form-field>
                          <input nbInput fullWidth placeholder="Nr" formControlName="number"
                                 [status]="hasHouseNumberError(i, j) ? 'danger' : 'basic'">

                          @if (!formGroup()?.disabled) {
                            <button nbSuffix nbButton ghost
                                    [status]="houseNumber.get('visible')?.value ? 'primary' : 'basic'"
                                    (click)="houseNumber.get('visible')?.setValue(!houseNumber.get('visible')?.value)"
                                    type="button"
                                    [nbTooltip]="houseNumber.get('visible')?.value ? 'Sichtbar' : 'Versteckt'">
                              <nb-icon pack="eva" [icon]="houseNumber.get('visible')?.value ? 'eye-outline' : 'eye-off-outline'"></nb-icon>
                            </button>
                          }
                          @if (!formGroup()?.disabled) {
                            <button nbSuffix nbButton ghost status="danger"
                                    (click)="deleteHouseNumber(i, j)" type="button"
                                    nbTooltip="Löschen">
                              <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
                            </button>
                          } @else {
                            <button nbSuffix nbButton ghost status="basic" type="button"
                                    class="visibility-indicator"
                                    [nbTooltip]="houseNumber.get('visible')?.value ? 'Sichtbar' : 'Versteckt (nicht im Gebäudetext)'">
                              <nb-icon pack="eva" [icon]="houseNumber.get('visible')?.value ? 'eye-outline' : 'eye-off-outline'"></nb-icon>
                            </button>
                          }
                        </nb-form-field>

                        @if (hasHouseNumberError(i, j)) {
                          <small class="text-danger">Erforderlich</small>
                        }
                      </div>
                    }
                  }

                  @if (!formGroup()?.disabled) {
                    <button nbButton ghost status="primary"
                            (click)="addHouseNumber(houseNumbers(i))" type="button">
                      <nb-icon pack="eva" icon="plus-outline"></nb-icon>
                    </button>
                  }
                </div>
              </div>
            </div>

            <wr-automatic-address formControlName="automaticAddress"></wr-automatic-address>
          </div>

          @if (!formGroup()?.disabled) {
            <div class="delete-merge-container">
                <button type="button"
                        nbButton
                        ghost
                        status="primary"
                        (click)="deleteBuildingSection(i)">
                  <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
                </button>
            </div>
          }
        </div>
        }
      }
    </div>
  </div>
}
